module.exports = __webpack_public_path__ + "static/1204586808-wide.73fc422d.jpg";